import { render } from "./SloganPrincipal.vue?vue&type=template&id=0bcb4d2a&scoped=true"
import script from "./SloganPrincipal.vue?vue&type=script&lang=js"
export * from "./SloganPrincipal.vue?vue&type=script&lang=js"

import "./SloganPrincipal.vue?vue&type=style&index=0&id=0bcb4d2a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcb4d2a"]])

export default __exports__